// extracted by mini-css-extract-plugin
export default {"cont":"Details_cont__7J2PP","details":"Details_details__7M7U1","buttonCont":"Details_buttonCont__IYfn6"};